<template>
    <div>
        <van-nav-bar :title="$t('onlineService')" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div>
            <van-cell v-show="$i18n.locale == 'en'" icon="img/mine/telegram.png" title="Telegram" is-link
                :clickable="false" center @click="toService('tg')"></van-cell>
            <van-cell v-show="$i18n.locale == 'en'" icon="img/mine/telegram.png" title="VVIP Customer Service" is-link
                :clickable="false" center @click="toService('ws')"></van-cell>
            <van-cell v-show="$i18n.locale == 'th'" icon="img/mine/line.png" title="LINE" is-link :clickable="false"
                center @click="toService('line')"></van-cell>
            <van-cell icon="img/mine/video.png" :title="$t('AdultVideos')" is-link :clickable="false" center
                @click="toService('18')"></van-cell>
        </div>
        <div style="font-size: 13px; padding: 30px 15px; line-height: 1.6;">{{ $t('serviceTip') }}</div>
    </div>
</template>

<script>
export default {
    name: "customerservice",
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        back() {
            return window.history.back();
        },
        toService(type) {
            let kefu = "";
            if (type == "tg") {
                kefu = this.$store.getters.getBaseInfo.online.replace(/\s*/g, "");
            } else if (type == "ws") {
                kefu = this.$store.getters.getBaseInfo.whatsapp.replace(/\s*/g, "");
            } else if (type == "line") {
                kefu = this.$store.getters.getBaseInfo.telegeram.replace(/\s*/g, "");
            } else if (type == "18") {
                kefu = this.$store.getters.getBaseInfo.line.replace(/\s*/g, "");
            }
            return window.location.href = kefu;
        },
    }
}
</script>

<style lang="less" scoped>
::v-deep .van-cell {
    // padding: 40px 60px;
    margin-top: 30px;
    font-size: 32px;
}

.van-icon__image {
    width: 50px;
    height: 50px;
}

.van-cell__left-icon {
    display: block;
    width: 50px;
    height: 50px;
}
</style>